export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/oneWayArrBlue.a1f360c0.svg","height":15,"width":22};